import ModelFactory from '../model-factory';
import { User } from '../user';
import { ActivityType } from '../models';
/**
 * format:
{
@COMMON_NAME: "Create a new request/incident/problem/change/issue"
@REL_ATTR: "alg:33142899"
@id: 33142899
action_desc: "Create a new request/incident/problem/change/issue"
analyst: {organization: {@id: "U'3C05152D54C901DE99E8001CC416E56E'",…},…}
@COMMON_NAME: "Pruebas Keyuser User"
@REL_ATTR: "U'507CDEB1220801F8A8A1000C29CEC9CF'"
@id: "U'507CDEB1220801F8A8A1000C29CEC9CF'"
contact_uuid: "U'507CDEB1220801F8A8A1000C29CEC9CF'"
organization: {@id: "U'3C05152D54C901DE99E8001CC416E56E'",…}
organization_uuid: "U'3C05152D54C901DE99E8001CC416E56E'"
call_req_id: {,…}
@COMMON_NAME: "4677325"
@REL_ATTR: "cr:5108059"
@id: 5108059
customer:
{contact_uuid: "U'507CDEB1220801F8A8A1000C29CEC9CF'",
@REL_ATTR: "U'507CDEB1220801F8A8A1000C29CEC9CF'",…}
ref_num: "4677325"
type: {@REL_ATTR: "R"}
description: "Create a new request/incident/problem/change/issue"
internal: 0
time_stamp: 1613406110
type:
{@id: 5602, @COMMON_NAME: "Creación", code: "INIT", @REL_ATTR: "INIT", zdescripcion_web: "Creada",…}
@COMMON_NAME: "Creación"
@REL_ATTR: "INIT"
@id: 5602
code: "INIT"
description: "Creada"
zdescripcion_web: "Creada"
}
 */

const ACTIVITY_ICON_TYPES = {
  DEFAULT: 'mdi-information-outline',
  INIT: 'mdi-file-document-outline',
  TR: 'mdi-source-branch',
  RECLA: 'mdi-help-circle-outline',
  LOG: 'mdi-comment-outline',
  SEG_USU: 'mdi-comment-outline',
  RS: 'mdi-magnify',
  CL: 'mdi-square-rounded-outline',
  CNCL: 'mdi-square-rounded-outline',
  ESC: 'mdi-swap-vertical-bold',
  ATTACHTDOC: 'mdi-paperclip',
  DETACHTDOC: 'mdi-trash-can-outline',
  RE: 'mdi-check-box-outline',
  RO: 'mdi-folder-open-outline',
  ST: 'mdi-twitter-retweet',
  APPROVED: 'mdi-check-circle-outline',
  ACT_PLANI: 'mdi-asterisk',
  RECLAMAR: 'mdi-asterisk',
  NF: 'mdi-asterisk',
  SRVY_VALUE: 'mdi-star-outline',
};

const HIDDEN_DESCRIPTION_TYPES = ['INIT'];

export default class Activity {
  constructor(data = {}) {
    this.ticketId = data.call_req_id || null;
    this.date = data.time_stamp || null;
    this.zplanif_motivo = data.zplanif_motivo || null;
    this.zplanif_motivo_description = data.zsym || null;
    this.zcheck = data.zcheck === 1 ? 1 : 0;

    this.analyst = null;
    if (data.analyst != null) {
      this.analyst = new User(data.analyst);
    }

    this.type = null;
    if (data.type != null) {
      this.type = new ActivityType(data.type);
    }

    this.icon = ACTIVITY_ICON_TYPES.DEFAULT;
    const typeCode = (this.type || {}).code;
    if (typeCode != null && ACTIVITY_ICON_TYPES[typeCode] != null) {
      this.icon = ACTIVITY_ICON_TYPES[typeCode];
    }

    this.description = null;
    if (typeCode != null && data.description != null
        && data.action_desc !== data.description
        && !HIDDEN_DESCRIPTION_TYPES.includes(typeCode)) {
      if (typeCode === 'DETACHTDOC') {
        this.description = data.description.replace(/Detach Document :/i, '');
      } else {
        this.description = data.description;
      }
    }

    this.actionDescription = null;
    if (typeCode != null && data.action_desc != null) {
      if (typeCode === 'ST') {
        // Status changed from 'Fijada' to 'Abierta'
        const from = data.action_desc.replace(/.*from\s*'(.*?)'\s*to\s*'(.*)?'.*/, '$1');
        const to = data.action_desc.replace(/.*from\s*'(.*?)'\s*to\s*'(.*)?'.*/, '$2');
        this.actionDescription = {
          from: from === 'Retrasada' ? 'Planificada' : from,
          to: to === 'Retrasada' ? 'Planificada' : to,
        };
      }
    }
  }
}

export const modelFactory = new ModelFactory('alg', (data) => new Activity(data));

// ST
// expr:".*from\s*'(.*?)'\s*to\s*'.*?'.*",
